module.exports = __webpack_public_path__ + "static/media/ic-opbnb.5e461ece.png";